
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { type BarConfig, type DrawCanvasType, DrawCanvas } from '@xt/client/utils/canvas/index'

export type BarChartsConfig = {
  // 柱间距
  barWidth: number
  // 柱圆角
  barRadius: number
  // 完成柱颜色
  completedColor: string
  // 应看柱颜色
  totalColor: string
  // 容器宽
  containerW: number
  // 容器高
  containerH: number
}

@Component({
  components: {}
})
export default class BarCharts extends Vue {
  @Prop({ type: Array, default: () => [] }) data: { completed: number; total: number }[]
  @Prop() config: BarChartsConfig

  @Ref()
  canvas: HTMLCanvasElement

  drawCanvas: DrawCanvasType

  // 计算绘制参数（修正变量作用域问题）
  getBarDrawParams(config: BarChartsConfig) {
    const { containerW: w, containerH: h, barWidth } = config
    const dataCount = this.data.length
    const totalWidth = dataCount * barWidth
    const barGap = (w - totalWidth) / (dataCount - 1)
    const maxTotal = Math.max(...this.data.map(item => item.total || 1)) // 避免0值
    const barHeight = h

    return { barGap, maxTotal, barHeight }
  }
  // 绘制所有柱子（修正barWidth作用域）
  drawBars() {
    const { barGap, maxTotal, barHeight } = this.getBarDrawParams(this.config)
    const { barRadius, completedColor, totalColor, barWidth } = this.config
    let currentX = 0

    this.data.forEach(item => {
      if (maxTotal === 0) return // 容错处理
      const totalHeight = (item.total / maxTotal) * barHeight
      const completedHeight = (Math.min(item.completed, item.total) / maxTotal) * barHeight
      const totalBar: BarConfig = {
        x: currentX,
        h: totalHeight,
        barWidth,
        color: totalColor,
        radius: barRadius,
        barHeight
      }
      const completedBar: BarConfig = {
        x: currentX,
        h: completedHeight,
        barWidth,
        color: completedColor,
        radius: barRadius,
        barHeight
      }

      this.drawCanvas.drawBar(totalBar)
      this.drawCanvas.drawBar(completedBar)

      currentX += barWidth + barGap
    })
  }

  drawChart() {
    this.drawCanvas = new DrawCanvas({
      canvas: this.canvas,
      config: this.config
    })
    this.drawCanvas.initCanvas()
    // 清除画布
    this.drawCanvas.clearDraw()
    this.drawBars()
  }

  created(): void {}

  mounted(): void {
    this.drawChart()
  }

  updated(): void {}

  beforeDestroy(): void {
    this.drawCanvas.clearDraw()
  }

  destroyed(): void {}
}
